import {
  LOGIN_USER,
  CLEAR_USER_DATA,
  USER_CART_SESSION,
  SET_CUSTOMER_DETAILS,
  SET_FIRSTNAME,
  SET_OTP_FLAG,
} from "actions/types";

let initialState = {
  userEmail: "",
  userCartToken: "",
  userDetails: {},
  firstname: "", 
  otpSendFlag : { otpSendToPhone : null , otpSendToEmail : null } ,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER: {
      return {
        ...state,
        userEmail: action.payload,
      };
    }
    case CLEAR_USER_DATA: {
      return {
        ...state,
        userEmail: "",
        userCartToken: "",
        userDetails: {},
        firstname: "",
      };
    }
    case USER_CART_SESSION: {
      return {
        ...state,
        userCartToken: action.payload,
      };
    }
    case SET_CUSTOMER_DETAILS: {
      return {
        ...state,
        userDetails: action.payload,
      };
    }
    case SET_FIRSTNAME: {
      return {
        ...state,
        firstname: action.payload,
      };
    } 

    case SET_OTP_FLAG : { 
      return { 
          ...state , 
          otpSendFlag : action.payload ,
      }
    }
    default: {
      return state;
    }
  }
};
